import { Box, Typography } from '@mui/material';

import type { FunctionComponent } from 'react';

const SelfCare: FunctionComponent = () => {
  return (
    <Box className="py-8">
      <Typography variant="body1">
        Self care is about taking steps to feel healthy and comfortable. Whether it happened recently or years ago, self-care can help you cope with the short- and long-term effects of a trauma like
        sexual assault.
      </Typography>
      <Typography variant="body1" className="font-bold pt-4">
        Physical self care
      </Typography>
      <Typography variant="body1">
        After a trauma, it’s important to keep your body healthy and strong. You may be healing from injuries or feeling emotionally drained. Good physical health can support you through this time.
        Think about a time when you felt physically healthy, and consider asking yourself the following questions:
        <ul className="rhs-hotlines-list">
          <li>How were you sleeping? Did you have a sleep ritual or nap pattern that made you feel more rested?</li>
          <li>What types of food were you eating? What meals made you feel healthy and strong?</li>
          <li>What types of exercise did you enjoy? Were there any particular activities that made you feel more energized?</li>
          <li>Did you perform certain routines? Were there activities you did to start the day off right or wind down at the end of the day?</li>
        </ul>
      </Typography>

      <Typography variant="body1" className="font-bold pt-4">
        Emotional self care
      </Typography>
      <Typography variant="body1">
        Emotional self care means different things to different people. The key to emotional self care is being in tune with yourself. Think about a time when you felt balanced and grounded, and
        consider asking yourself the following questions:
        <ul className="rhs-hotlines-list">
          <li>What fun or leisure activities did you enjoy? Were there events or outings that you looked forward to?</li>
          <li>Were meditation or relaxation activities a part of your regular schedule?</li>
          <li>What inspirational words were you reading? Did you have a particular author or favorite website, like RAINN’s Pinterest board, to go to for inspiration?</li>
          <li>Who did you spend time with? Was there someone, or a group of people, that you felt safe and supported around?</li>
          <li>Where did you spend your time? Was there a special place, maybe outdoors or at a friend’s house, where you comfortable and grounded?</li>
        </ul>
        Self care isn’t always easy to take on by yourself. To speak with someone who is trained to help, call the {process.env.NX_ORGANIZATION_NAME} at 800.656.HOPE(4673) or chat online at
        online.rainn.org.
      </Typography>
    </Box>
  );
};
export default SelfCare;
